import {isEmpty} from 'lodash'
import {useSelector} from './redux'

const key = (prefix: string | undefined, userId: string) => `${prefix || ''}#${userId}__added_fields`

const getAddedFields = (keyPrefix: string | undefined, userId: string): string[] => {
  if (window.localStorage) {
    const saved = window.localStorage.getItem(key(keyPrefix, userId))
    if (saved) {
      return JSON.parse(saved)
    }
  }
  return []
}

const saveAddedFields = (keyPrefix: string | undefined, userId: string, addedFields: string[] | undefined) => {
  if (window.localStorage) {
    const normalized = addedFields?.length ? addedFields : []
    window.localStorage.setItem(key(keyPrefix, userId), JSON.stringify(normalized))
  }
}

export const useAddedFields = (keyPrefix?: string): [string[], (addedFields: string[] | undefined) => void] => {
  const currentUser = useSelector((state) => state.session.currentUser)
  return [getAddedFields(keyPrefix, currentUser.id), saveAddedFields.bind(null, keyPrefix, currentUser.id)]
}

interface AddFieldOption {
  value: string
  fields?: string[]
}

// addedFieldsと検索クエリに有効な値を持つ追加フィールドの和を返す
export const makeAddedFields = (
  addedFields: string[],
  searchParams: Record<string, unknown>,
  fields: AddFieldOption[]
): string[] => {
  const hasQueryFields = fields
    .filter(({value, fields}) => (fields || [value]).some((key) => !isEmpty(searchParams[key])))
    .map(({value}) => value)
  return [...new Set(addedFields).union(new Set(hasQueryFields))]
}
